import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { TechnicianService } from '../../../../../../services/technician.service';
import { Time } from '@angular/common';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { HelpersService } from '../../../../../../services/helpers.service';

@Component({
  selector: 'app-add-edit-staff-leave',
  templateUrl: './add-edit-staff-leave.component.html',
  styleUrls: ['./add-edit-staff-leave.component.scss'],
  providers: [MessageService],
})
export class AddEditStaffLeaveComponent implements OnInit {
  @Input() technicians;
  @Input() event: any;
  public technicianOptions: any = [];
  public technician: any = {};

  public minDate: Date = new Date();
  public startTime: Date = new Date(0, 0, 0, 8, 0, 0);
  public endTime: Date = new Date(0, 0, 0, 9, 0, 0);
  public busy: boolean = false;
  public weekDays: any = {
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
  };
  public countryData: any = {};

  constructor(
    public modal: NgbActiveModal,
    public messageService: MessageService,
    private translate: TranslateService,
    private technicianService: TechnicianService,
    public confirmationService: ConfirmationService,
    private helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.technicianOptions = this.technicians.map((x) => {
      return {
        value: x.TechnicianID || x.id,
        label: x.TechnicianID ? x.Name + ' ' + x.Surname : x.Name,
      };
    });
    if (this.event && this.event.ID) {
      (this.technician = this.event.TechnicianID),
        (this.event.StartTime = new Date(this.event.StartTime));
      this.event.EndTime = new Date(this.event.EndTime);
      this.startTime = this.event.StartTime;
      this.endTime = this.event.EndTime;
    } else {
      this.event = {
        Description: '',
        StartTime: new Date(),
        EndTime: new Date(),
        IsRecurringEvent: false,
        RecurIntervalDays: 0,
        RecurringCount: 0,
        endDate: null,
      };
    }
  }

  valid() {
    return (
      this.technician &&
      this.technician > 0 &&
      this.event.Description &&
      this.event.Description.length > 0 &&
      this.event.StartTime &&
      (this.event.IsRecurringEvent ? this.event.endDate !== null : true) &&
      (this.event.IsRecurringEvent
        ? this.weekDays.Monday ||
          this.weekDays.Tuesday ||
          this.weekDays.Wednesday ||
          this.weekDays.Thursday ||
          this.weekDays.Friday ||
          this.weekDays.Saturday ||
          this.weekDays.Sunday
        : true)
    );
  }

  saveEvent() {
    let tzoffset = new Date().getTimezoneOffset() * 60000;
    this.event.StartTime = new Date(
      this.event.StartTime.getFullYear(),
      this.event.StartTime.getMonth(),
      this.event.StartTime.getDate(),
      this.startTime.getHours(),
      this.startTime.getMinutes(),
      0,
    );
    this.event.EndTime = new Date(
      this.event.StartTime.getFullYear(),
      this.event.StartTime.getMonth(),
      this.event.StartTime.getDate(),
      this.endTime.getHours(),
      this.endTime.getMinutes(),
      0,
    );

    if (!this.event.ID) {
      this.busy = true;
      this.technicianService
        .createCalendarEventRecurring(
          this.technician,
          this.event.Description,
          moment(this.event.StartTime - tzoffset).toISOString(false),
          moment(this.event.EndTime - tzoffset).toISOString(false),
          this.event.IsRecurringEvent,
          this.weekDays.Monday,
          this.weekDays.Tuesday,
          this.weekDays.Wednesday,
          this.weekDays.Thursday,
          this.weekDays.Friday,
          this.weekDays.Saturday,
          this.weekDays.Sunday,
          this.event.endDate
            ? moment(this.event.endDate - tzoffset).toISOString(false)
            : null,
        )
        .subscribe((event) => {
          this.busy = false;
          this.modal.close();
        });
    } else {
      this.busy = true;
      this.technicianService
        .updateCalendarEvent(
          this.event.ID,
          this.technician,
          this.event.Description,
          moment(this.event.StartTime - tzoffset).toISOString(false),
          moment(this.event.EndTime - tzoffset).toISOString(false),
          this.event.IsRecurringEvent,
          this.event.RecurringCount,
          this.event.RecurIntervalDays,
        )
        .subscribe((event) => {
          this.busy = false;
          this.modal.close();
        });
    }
  }

  deleteEvent() {
    this.busy = true;
    if (this.event.RecurrenceID > 0) {
      this.confirmationService.confirm({
        key: 'remove_recurring_events',
        message: this.translate.instant(
          'bikeshop.users.delete_recurring_events',
        ),
        acceptLabel: this.translate.instant('general.yes'),
        rejectLabel: this.translate.instant('general.no'),
        accept: () => {
          this.technicianService
            .cancelCalendarEvent(this.technician, this.event.ID, true)
            .subscribe((result) => {
              this.modal.close();
              this.busy = false;
            });
        },
        reject: () => {
          this.technicianService
            .cancelCalendarEvent(this.technician, this.event.ID, false)
            .subscribe((result) => {
              this.modal.close();
              this.busy = false;
            });
        },
      });
    } else {
      this.technicianService
        .cancelCalendarEvent(this.technician, this.event.ID, true)
        .subscribe((result) => {
          this.modal.close();
          this.busy = false;
        });
    }
  }
}
